<template>
    <editor
        key="default"
        :api-key="apiKey"
        :init="initEditorSettings"
        @input="$emit('input', $event)"
    />
</template>

<script>
import Editor from '@tinymce/tinymce-vue';

import { tinymce } from '@/config';

export default {
    components: {
        Editor
    },

    props: {
        question: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            apiKey: tinymce,
            initEditorSettings: {
                height: 400,
                menubar: 'table',
                plugins: [
                    'code advlist autolink lists link image charmap print preview anchor',
                    'searchreplace visualblocks code fullscreen',
                    'insertdatetime media table paste code help wordcount',
                    'directionality'
                ],
                toolbar: `
                    code | undo redo | formatselect fontsizeselect | bold italic backcolor forecolor|
                    alignleft aligncenter alignright alignjustify |
                    bullist numlist outdent indent | removeformat | help
                `,
                table_appearance_options: false,
                relative_urls: false
            }
        };
    }
};
</script>
